import styled from 'styled-components';

export const StyledOverlay = styled.div<{ backgroundColor: string }>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: ${({ backgroundColor }) => backgroundColor || 'rgba(0,0,0,0.8)'};
  z-index: var(--z-index-high);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  h2 {
    font-weight: 600;
  }

  p {
    color: white;
    font-size: 18px;
    max-width: 300px;
    text-align: center;
  }

  button {
    background: transparent;
    height: fit-content;
    width: fit-content;
    text-decoration: underline;
    cursor: pointer;
  }
` as any;
